import React from 'react';
import PropTypes from 'prop-types';

import { StyledSubMenuWrapper, StyledHorizontalScrollUl, StyledLi, StyledGradient } from './CollectionSubMenuStyles';

var CollectionSubMenu = function CollectionSubMenu(_ref) {
  var subMenu = _ref.subMenu,
      currentUrl = _ref.currentUrl,
      isTouchDevice = _ref.isTouchDevice;
  return React.createElement(
    StyledSubMenuWrapper,
    null,
    React.createElement(
      StyledHorizontalScrollUl,
      null,
      subMenu.map(function (link) {
        return React.createElement(
          StyledLi,
          { key: link.title, currentUrl: currentUrl === link.url },
          React.createElement(
            'a',
            { href: link.url },
            link.title
          )
        );
      })
    ),
    React.createElement(StyledGradient, { isTouchDevice: isTouchDevice })
  );
};

CollectionSubMenu.propTypes = {
  currentUrl: PropTypes.string.isRequired,
  subMenu: PropTypes.array.isRequired,
  isTouchDevice: PropTypes.bool
};

export default CollectionSubMenu;